import { Injectable } from '@angular/core';
import { ObbBuilder } from '../collision/obb-builder.service';
import { CollisionService } from '../collision/collision.service';

declare let THREE: any;

var snapToWall = function (position, wall) {

  var floorOffset = position.y;
  var wallDirection = wall.getWorldDirection(new THREE.Vector3());
  var result = position.clone();

  var dif = wall.position.clone().sub(position);
  dif.projectOnVector(wallDirection);

  result.add(dif);
  result.y = floorOffset;

  return result;
};

@Injectable()
export class WallHelperService {

  constructor(
    private collisionSrvc: CollisionService
  ) { }


    wall;
    obb;
    snapPosition;
    offset;
    entity;

  getIntersectedWall(walls, object) {

    object.updateMatrixWorld();

    this.wall = this.getWallInHotZone(object, walls);

    if (this.wall)
      return this.wall;

    this.obb = new ObbBuilder()
      .setBoundingBox(object.userData.boundingBox)
      .build(object);

    return this.collisionSrvc.objectOBBIntersectWalls(this.obb, walls);
  }

  highlight(wall) {
    if (wall) {
      // wall.material.materials[2].color.setHex(constants.HighlightState.SELECTED);
    }
  }

  unHighlight(wall) {
    if (wall) {
      // wall.material.materials[2].color.setHex(constants.HighlightState.DEFAULT);
    }
  }

  mountToWall(position, wall) {

    this.snapPosition = snapToWall(position.clone(), wall);

    if (this.snapPosition) {
      // this.offset = wall.getWorldDirection(new THREE.Vector3()).multiplyScalar(constants.wallWidth / 2);
      this.snapPosition.sub(this.offset);
    }

    return this.snapPosition;
  }

  snapToWallWithGap(object, wall) {

    var entity = object.userData.entity,
      border = entity.borders,
      snapPosition = snapToWall(object.position, wall),
      wallDirection = wall.getWorldDirection(new THREE.Vector3());

    if (snapPosition) {

      if (border && border.wall) {
        var gapOffset = wallDirection.clone().multiplyScalar(parseFloat(border.wall));
        snapPosition.add(gapOffset);
      }

      var offset = new THREE.Vector3(entity.length / 2 + 0.1, 0, entity.width / 2 + 0.1)
        .applyAxisAngle(new THREE.Vector3(0, 1, 0), object.rotation.y)
        .projectOnVector(wallDirection);
      snapPosition.add(wallDirection.multiplyScalar(offset.length()));
    }

    return snapPosition;
  }

  getWallInHotZone(object, walls) {

    this.entity = object.userData.entity;

    if (!this.entity.hotzones || !this.entity.hotzones.wall)
      return null;

    var halfOfLength = this.entity.length / 2,
      halfOfWidth = this.entity.width / 2,
      matrix = object.matrixWorld.clone(),
      rotation = new THREE.Matrix4().extractRotation(matrix),
      i = 0,
      intersection,
      rayCaster,
      edgeRays = [
        new THREE.Raycaster(new THREE.Vector3(0, halfOfWidth, 0), new THREE.Vector3(0, 0, 1)), //up
        new THREE.Raycaster(new THREE.Vector3(0, -halfOfWidth, 0), new THREE.Vector3(0, 0, -1)), //down
        new THREE.Raycaster(new THREE.Vector3(halfOfLength, 0, 0), new THREE.Vector3(1, 0, 0)), //right
        new THREE.Raycaster(new THREE.Vector3(-halfOfLength, 0, 0), new THREE.Vector3(-1, 0, 0)) //left
      ];

    for (; i < edgeRays.length; i++) {
      rayCaster = edgeRays[i];
      rayCaster.ray.origin.applyMatrix4(matrix);
      rayCaster.ray.direction.applyMatrix4(rotation);
      rayCaster.far = parseFloat(this.entity.hotzones.wall) || 1;
      intersection = rayCaster.intersectObjects(walls)[0];
      if (intersection)
        return intersection.object;
    }

    return null;
  }
}





// WEBPACK FOOTER //
// ./src/app/services/wall/wall-helper.service.ts